import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReportFieldFragment = { __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean };

export type ReportTopicFragment = { __typename?: 'ReportTopic', id: string, displayName: string, fields: Array<{ __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean }> };

export type ReportTopicsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReportTopicsQuery = { __typename?: 'Query', ReportTopics: Array<{ __typename?: 'ReportTopic', id: string, displayName: string, fields: Array<{ __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean }> }> };

export type ReportFilterFragment = { __typename?: 'ReportFilter', id: string, operator: Types.Operator, reportField: { __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean }, value: { __typename?: 'ReportFilterValue', stringInput?: string | null, listInput?: Array<string> | null, locationFilters?: { __typename?: 'LocationFilters', locations?: Array<{ __typename?: 'Location', id: number }> | null, locationGroups?: Array<{ __typename?: 'LocationGroup', id: string }> | null } | null, roleFilters?: { __typename?: 'RoleFilters', roles: Array<{ __typename?: 'Role', id: number }> } | null, regionFilters?: { __typename?: 'RegionFilters', regions: Array<{ __typename?: 'LocationGroup', id: string }> } | null } };

export type FieldFragment = { __typename?: 'CustomReportFieldMemberships', index: number, field: { __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean } };

export type EmailScheduleFragment = { __typename?: 'ScheduledReport', sendOn: string, sendAt: string, recipients: Array<{ __typename?: 'ScheduledReportRecipient', id: string, email?: string | null, user?: { __typename?: 'Employee', id: number, name: string } | null }> };

export type SavedReportFragment = { __typename?: 'CustomReport', id: string, title: string, sortAscending?: boolean | null, topic: { __typename?: 'ReportTopic', id: string, displayName: string, fields: Array<{ __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean }> }, fields: Array<{ __typename?: 'CustomReportFieldMemberships', index: number, field: { __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean } }>, sortBy?: { __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean } | null, filters?: Array<{ __typename?: 'ReportFilter', id: string, operator: Types.Operator, reportField: { __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean }, value: { __typename?: 'ReportFilterValue', stringInput?: string | null, listInput?: Array<string> | null, locationFilters?: { __typename?: 'LocationFilters', locations?: Array<{ __typename?: 'Location', id: number }> | null, locationGroups?: Array<{ __typename?: 'LocationGroup', id: string }> | null } | null, roleFilters?: { __typename?: 'RoleFilters', roles: Array<{ __typename?: 'Role', id: number }> } | null, regionFilters?: { __typename?: 'RegionFilters', regions: Array<{ __typename?: 'LocationGroup', id: string }> } | null } }> | null, emailSchedule?: { __typename?: 'ScheduledReport', sendOn: string, sendAt: string, recipients: Array<{ __typename?: 'ScheduledReportRecipient', id: string, email?: string | null, user?: { __typename?: 'Employee', id: number, name: string } | null }> } | null };

export type GetSavedReportsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSavedReportsQuery = { __typename?: 'Query', GetSavedReports?: Array<{ __typename?: 'CustomReport', id: string, title: string, sortAscending?: boolean | null, topic: { __typename?: 'ReportTopic', id: string, displayName: string, fields: Array<{ __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean }> }, fields: Array<{ __typename?: 'CustomReportFieldMemberships', index: number, field: { __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean } }>, sortBy?: { __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean } | null, filters?: Array<{ __typename?: 'ReportFilter', id: string, operator: Types.Operator, reportField: { __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean }, value: { __typename?: 'ReportFilterValue', stringInput?: string | null, listInput?: Array<string> | null, locationFilters?: { __typename?: 'LocationFilters', locations?: Array<{ __typename?: 'Location', id: number }> | null, locationGroups?: Array<{ __typename?: 'LocationGroup', id: string }> | null } | null, roleFilters?: { __typename?: 'RoleFilters', roles: Array<{ __typename?: 'Role', id: number }> } | null, regionFilters?: { __typename?: 'RegionFilters', regions: Array<{ __typename?: 'LocationGroup', id: string }> } | null } }> | null, emailSchedule?: { __typename?: 'ScheduledReport', sendOn: string, sendAt: string, recipients: Array<{ __typename?: 'ScheduledReportRecipient', id: string, email?: string | null, user?: { __typename?: 'Employee', id: number, name: string } | null }> } | null }> | null };

export type RunReportFragment = { __typename?: 'ReportMutationResult', objects: Array<{ [key: string]: any }>, totalCount: number };

export type RunReportMutationVariables = Types.Exact<{
  input: Types.ReportInput;
}>;


export type RunReportMutation = { __typename?: 'Mutation', runReport: { __typename?: 'ReportMutationResult', objects: Array<{ [key: string]: any }>, totalCount: number } };

export type SaveReportMutationVariables = Types.Exact<{
  input: Types.SaveReportInput;
}>;


export type SaveReportMutation = { __typename?: 'Mutation', saveReport: { __typename?: 'SavedReportMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null, savedReport?: { __typename?: 'CustomReport', id: string, title: string, sortAscending?: boolean | null, topic: { __typename?: 'ReportTopic', id: string, displayName: string, fields: Array<{ __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean }> }, fields: Array<{ __typename?: 'CustomReportFieldMemberships', index: number, field: { __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean } }>, sortBy?: { __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean } | null, filters?: Array<{ __typename?: 'ReportFilter', id: string, operator: Types.Operator, reportField: { __typename?: 'ReportField', id: string, displayName: string, type: Types.FieldType, index: number, disableFiltering: boolean }, value: { __typename?: 'ReportFilterValue', stringInput?: string | null, listInput?: Array<string> | null, locationFilters?: { __typename?: 'LocationFilters', locations?: Array<{ __typename?: 'Location', id: number }> | null, locationGroups?: Array<{ __typename?: 'LocationGroup', id: string }> | null } | null, roleFilters?: { __typename?: 'RoleFilters', roles: Array<{ __typename?: 'Role', id: number }> } | null, regionFilters?: { __typename?: 'RegionFilters', regions: Array<{ __typename?: 'LocationGroup', id: string }> } | null } }> | null, emailSchedule?: { __typename?: 'ScheduledReport', sendOn: string, sendAt: string, recipients: Array<{ __typename?: 'ScheduledReportRecipient', id: string, email?: string | null, user?: { __typename?: 'Employee', id: number, name: string } | null }> } | null } | null } };

export const ReportFieldFragmentDoc = gql`
    fragment ReportField on ReportField {
  id
  displayName
  type
  index
  disableFiltering
}
    `;
export const ReportTopicFragmentDoc = gql`
    fragment ReportTopic on ReportTopic {
  id
  displayName
  fields {
    ...ReportField
  }
}
    ${ReportFieldFragmentDoc}`;
export const FieldFragmentDoc = gql`
    fragment Field on CustomReportFieldMemberships {
  field {
    ...ReportField
  }
  index
}
    ${ReportFieldFragmentDoc}`;
export const ReportFilterFragmentDoc = gql`
    fragment ReportFilter on ReportFilter {
  id
  reportField {
    ...ReportField
  }
  value {
    stringInput
    listInput
    locationFilters {
      locations {
        id
      }
      locationGroups {
        id
      }
    }
    roleFilters {
      roles {
        id
      }
    }
    regionFilters {
      regions {
        id
      }
    }
  }
  operator
}
    ${ReportFieldFragmentDoc}`;
export const EmailScheduleFragmentDoc = gql`
    fragment EmailSchedule on ScheduledReport {
  sendOn
  sendAt
  recipients {
    id
    email
    user {
      id
      name
    }
  }
}
    `;
export const SavedReportFragmentDoc = gql`
    fragment SavedReport on CustomReport {
  id
  title
  topic {
    ...ReportTopic
  }
  fields {
    ...Field
  }
  sortBy {
    ...ReportField
  }
  sortAscending
  filters {
    ...ReportFilter
  }
  emailSchedule {
    ...EmailSchedule
  }
}
    ${ReportTopicFragmentDoc}
${FieldFragmentDoc}
${ReportFieldFragmentDoc}
${ReportFilterFragmentDoc}
${EmailScheduleFragmentDoc}`;
export const RunReportFragmentDoc = gql`
    fragment RunReport on ReportMutationResult {
  objects
  totalCount
}
    `;
export const ReportTopicsDocument = gql`
    query ReportTopics {
  ReportTopics {
    ...ReportTopic
  }
}
    ${ReportTopicFragmentDoc}`;

/**
 * __useReportTopicsQuery__
 *
 * To run a query within a React component, call `useReportTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportTopicsQuery(baseOptions?: Apollo.QueryHookOptions<ReportTopicsQuery, ReportTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportTopicsQuery, ReportTopicsQueryVariables>(ReportTopicsDocument, options);
      }
export function useReportTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportTopicsQuery, ReportTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportTopicsQuery, ReportTopicsQueryVariables>(ReportTopicsDocument, options);
        }
export type ReportTopicsQueryHookResult = ReturnType<typeof useReportTopicsQuery>;
export type ReportTopicsLazyQueryHookResult = ReturnType<typeof useReportTopicsLazyQuery>;
export type ReportTopicsQueryResult = Apollo.QueryResult<ReportTopicsQuery, ReportTopicsQueryVariables>;
export const GetSavedReportsDocument = gql`
    query GetSavedReports {
  GetSavedReports {
    ...SavedReport
  }
}
    ${SavedReportFragmentDoc}`;

/**
 * __useGetSavedReportsQuery__
 *
 * To run a query within a React component, call `useGetSavedReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSavedReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetSavedReportsQuery, GetSavedReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedReportsQuery, GetSavedReportsQueryVariables>(GetSavedReportsDocument, options);
      }
export function useGetSavedReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedReportsQuery, GetSavedReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedReportsQuery, GetSavedReportsQueryVariables>(GetSavedReportsDocument, options);
        }
export type GetSavedReportsQueryHookResult = ReturnType<typeof useGetSavedReportsQuery>;
export type GetSavedReportsLazyQueryHookResult = ReturnType<typeof useGetSavedReportsLazyQuery>;
export type GetSavedReportsQueryResult = Apollo.QueryResult<GetSavedReportsQuery, GetSavedReportsQueryVariables>;
export const RunReportDocument = gql`
    mutation RunReport($input: ReportInput!) {
  runReport(input: $input) {
    ...RunReport
  }
}
    ${RunReportFragmentDoc}`;
export type RunReportMutationFn = Apollo.MutationFunction<RunReportMutation, RunReportMutationVariables>;

/**
 * __useRunReportMutation__
 *
 * To run a mutation, you first call `useRunReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runReportMutation, { data, loading, error }] = useRunReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunReportMutation(baseOptions?: Apollo.MutationHookOptions<RunReportMutation, RunReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunReportMutation, RunReportMutationVariables>(RunReportDocument, options);
      }
export type RunReportMutationHookResult = ReturnType<typeof useRunReportMutation>;
export type RunReportMutationResult = Apollo.MutationResult<RunReportMutation>;
export type RunReportMutationOptions = Apollo.BaseMutationOptions<RunReportMutation, RunReportMutationVariables>;
export const SaveReportDocument = gql`
    mutation SaveReport($input: SaveReportInput!) {
  saveReport(input: $input) {
    success
    error {
      message
    }
    savedReport {
      ...SavedReport
    }
  }
}
    ${SavedReportFragmentDoc}`;
export type SaveReportMutationFn = Apollo.MutationFunction<SaveReportMutation, SaveReportMutationVariables>;

/**
 * __useSaveReportMutation__
 *
 * To run a mutation, you first call `useSaveReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReportMutation, { data, loading, error }] = useSaveReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveReportMutation(baseOptions?: Apollo.MutationHookOptions<SaveReportMutation, SaveReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveReportMutation, SaveReportMutationVariables>(SaveReportDocument, options);
      }
export type SaveReportMutationHookResult = ReturnType<typeof useSaveReportMutation>;
export type SaveReportMutationResult = Apollo.MutationResult<SaveReportMutation>;
export type SaveReportMutationOptions = Apollo.BaseMutationOptions<SaveReportMutation, SaveReportMutationVariables>;